import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import queryString from 'querystringify';
import Create from './Create';
import Update from './Edit';
import Delete from './Delete';
import { list, table } from '../../store/actions';
import Tables from '../../components/DynamicTables';

const columns = [
  {
    Header:'Judul',
    accessor: 'title'
  },
  {
    Header: 'Deskripsi',
    accessor: 'description'
  },
  {
    Header: 'Categories ',
    accessor: 'type'
  },
  {
    Header: 'Tags',
    accessor:'tags'
  },
  // {
  //   Header: 'Status',
  //   accessor: 'status'
  // }
]

class Artikel extends Component {
  state = {
    isCreate: false,
    isUpdate: false,
    isDelete: false,
    originalData: []
  }

  loadModules = (param) => {
    const { articleParams } = this.props
    const query = {
      page: param?.page || 1, 
      keyword: param?.keyword || '',
      sortBy: articleParams?.sortBy
    }
    const payload = {
      name: 'posts',
      customName: 'post',
      query: queryString.stringify(query)
    }
    this.props.list(payload)
  }

  componentDidMount() {
    const { query, table } = this.props
    if(query.page !== 1){
      table({ page: 1, keyword: '' })
    }else{
      table({ keyword: '' })
      this.loadModules({
        page: query.page,
        keyword: ''
      })
    }
  }

  componentDidUpdate(nextProps) {
    const { query, articleParams } = this.props
    if ((nextProps.query !== query) || (nextProps.articleParams !== articleParams)) {
        this.loadModules(query)
    }
  }

  // handleView = (data) => {
  //   const { history } = this.props
  //   const { uuid } = data.original
  //   history.push(`/post/${uuid}`)
  // }
  handleDelete = (data, isDelete) => {
    let originalData = data && data.original

    this.setState({
      isDelete: true,
      originalData: originalData
    })
  }

  handleCreate = (isCreate) => {
    this.setState({
      isCreate: true ,
    })
  }
  
  handleUpdate = (data,isUpdate) => {
    let originalData = data && data.original

    this.setState({
      isUpdate: true,
      originalData: originalData
    })
  }
  
  render() {
    const { data } = this.props
    let result = (data && data.data.data && data.data.data) || []
    const { isCreate, isUpdate, isDelete, originalData } = this.state;
    return (
      <React.Fragment>
        <div className="page-content">
          <div className="container-fluid">
            <Tables
              withFilter={{ placeHolder: 'Cari Artikel'}}
              withSelectRow
              withPagination
              title="Artikel"
              name="tasklist" // following the name or customName in this.props.list
              columns={columns}
              withCreate={(isCreate) => this.handleCreate(isCreate)}
              data={result}
              lastPage={data?.data?.last_page}
              totalData={data?.data.total}
              actions={[
                { label: 'Update', color: 'light', action: (data, isUpdate) => this.handleUpdate(data,isUpdate) },
                { label: 'Delete', color: 'danger', action: (data, isDelete) => this.handleDelete(data,isDelete) }
              ]}
            />
            <Create 
              isOpen={isCreate}
              onClose={()=> this.setState({ isCreate: false})}
            />
            <Update
              isOpen={isUpdate}
              onClose={() => this.setState({ isUpdate: false })}
              initialData={originalData}
            />
            <Delete
              isOpen={isDelete}
              onClose={() => this.setState({ isDelete: false })}
              original={originalData}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = state => {
  return {
    data: state.module.list.post,
    query: state.module.table,
    articleParams: state.module.articleParams
  };
};

export default connect(mapStatetoProps, { list, table })(Artikel);
